import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransferStoreWorkshopDetailTableModel } from 'src/app/models/tables/maintenance/transfer-store-workshop-detail-table.model';
import { TransferStoreWorkshopTableModel } from 'src/app/models/tables/maintenance/transfer-store-workshop-table.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { TransferStoreWorkshopDetailService } from 'src/app/services/maintenance/transfer-store-workshop-detail.service';
import { TransferStoreWorkshopService } from 'src/app/services/maintenance/transfer-store-workshop.service';

@Component({
  selector: 'app-transfer-store-workshop',
  templateUrl: './transfer-store-workshop.component.html',
  styleUrls: ['./transfer-store-workshop.component.scss'],
  standalone: false
})
export class TransferStoreWorkshopComponent implements OnInit {

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  detailData: PagedResponseModel<TransferStoreWorkshopDetailTableModel> =
    new PagedResponseModel<TransferStoreWorkshopDetailTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<TransferStoreWorkshopTableModel> =
    new PagedResponseModel<TransferStoreWorkshopTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  limit: number = 10;
  nameWindow: string = 'Traslado Almacén Taller';
  page: number = 1;
  projectName = ProjectName.projectName;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = 'transfer-store-workshop'

  constructor(private headerService: HeaderService,
    private router: Router,
    private title: Title,
    private transferStoreWorkshopDetailService: TransferStoreWorkshopDetailService,
    private transferStoreWorkshopService: TransferStoreWorkshopService) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    filters ? this.filters = JSON.parse(filters) : [];
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getAllTransferStoreWorkshopsWithPagination(),
    ]);
  }

  async exportDetailConsultation() {
    try {
      const blob = await firstValueFrom(this.transferStoreWorkshopDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.nameWindow} Detalle.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los detalles de los traslados almacén taller.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const blob = await firstValueFrom(this.transferStoreWorkshopService.exportGeneralConsultation(this.filters,
        this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.nameWindow}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los traslados almacén taller.', error);
    }
  }


  async getAllTransferStoreWorkshopsWithPagination() {
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.getAllTransferStoreWorkshopsWithPagination(this.page,
        this.limit, this.columnSort, this.ascendant, this.filters));
      this.generalData = response;
    } catch (error) {
      console.error('Error al buscar los traslados almacén taller.', error);
    }
  }

  async getAllTransferStoreWorkshopDetailsWithPagination() {
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopDetailService.getAllTransferStoreWorkshopDetailsWithPagination(this.page,
        this.limit, this.columnSort, this.ascendant, this.filters));
      this.detailData = response;
    } catch (error) {
      console.error('Error al buscar los detalles de los traslados almacén taller.', error);
    }
  }

  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        const response = await firstValueFrom(this.transferStoreWorkshopDetailService.getColumnsForDetailConsultation());
        this.detailHeader = response;
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta detalle.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        const response = await firstValueFrom(this.transferStoreWorkshopService.getColumnsForGeneralConsultation());
        this.generalHeader = response;
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0: {
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getAllTransferStoreWorkshopsWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      }

      case 1: {
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getAllTransferStoreWorkshopDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      }
    }
  }

  newRegister() {
    this.router.navigate([`/${this.url}/register`]);
  }

  onAction(event: { action: string, item?: TransferStoreWorkshopTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/${this.url}/register/${event.item.id}`]);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getAllTransferStoreWorkshopsWithPagination();
        break;
      case 1:
        await this.getAllTransferStoreWorkshopDetailsWithPagination();
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0: {
        await this.exportGeneralConsultation();
        break;
      }
      case 1: {
        await this.exportDetailConsultation();
        break;
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  private removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  private processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
